import { Component } from '@angular/core';

import { App, NavController, ModalController, ViewController } from 'ionic-angular';


@Component({
    template: `
    <ion-list>
      <button ion-item (click)="close('readall')">Tout marquer comme lu</button>
    </ion-list>
  `
})
export class NotificationsPopover {

    constructor(
        public viewCtrl: ViewController,
        public navCtrl: NavController,
        public app: App,
        public modalCtrl: ModalController
    ) { }

    support() {
        this.app.getRootNav().push('SupportPage');
        this.viewCtrl.dismiss();
    }

    close(action) {

        this.viewCtrl.dismiss(action);
    }
}


// WEBPACK FOOTER //
// ./src/pages/account/notifications/popover.ts